// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

export class FileAudioContainerMetadataBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):FileAudioContainerMetadataBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsFileAudioContainerMetadataBuf(bb:flatbuffers.ByteBuffer, obj?:FileAudioContainerMetadataBuf):FileAudioContainerMetadataBuf {
  return (obj || new FileAudioContainerMetadataBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsFileAudioContainerMetadataBuf(bb:flatbuffers.ByteBuffer, obj?:FileAudioContainerMetadataBuf):FileAudioContainerMetadataBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new FileAudioContainerMetadataBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

album():string|null
album(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
album(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

albumArtist():string|null
albumArtist(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
albumArtist(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

artist():string|null
artist(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
artist(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

beatsPerMinute():number|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : null;
}

comment():string|null
comment(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
comment(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

composer():string|null
composer(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
composer(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

copyright():string|null
copyright(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
copyright(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

encoder():string|null
encoder(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
encoder(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

encodedBy():string|null
encodedBy(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
encodedBy(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

genre():string|null
genre(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
genre(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

language():string|null
language(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
language(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

performer():string|null
performer(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
performer(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

trackNumber():bigint|null {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : null;
}

disc():bigint|null {
  const offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : null;
}

title():string|null
title(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
title(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 32);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

date():string|null
date(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
date(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 34);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

bitrate():bigint|null {
  const offset = this.bb!.__offset(this.bb_pos, 36);
  return offset ? this.bb!.readUint64(this.bb_pos + offset) : null;
}

lyrics():string|null
lyrics(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
lyrics(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 38);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

rating():number|null {
  const offset = this.bb!.__offset(this.bb_pos, 40);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : null;
}

urlSource():string|null
urlSource(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
urlSource(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 42);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startFileAudioContainerMetadataBuf(builder:flatbuffers.Builder) {
  builder.startObject(20);
}

static addAlbum(builder:flatbuffers.Builder, albumOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, albumOffset, 0);
}

static addAlbumArtist(builder:flatbuffers.Builder, albumArtistOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, albumArtistOffset, 0);
}

static addArtist(builder:flatbuffers.Builder, artistOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, artistOffset, 0);
}

static addBeatsPerMinute(builder:flatbuffers.Builder, beatsPerMinute:number) {
  builder.addFieldFloat64(3, beatsPerMinute, null);
}

static addComment(builder:flatbuffers.Builder, commentOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, commentOffset, 0);
}

static addComposer(builder:flatbuffers.Builder, composerOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, composerOffset, 0);
}

static addCopyright(builder:flatbuffers.Builder, copyrightOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, copyrightOffset, 0);
}

static addEncoder(builder:flatbuffers.Builder, encoderOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, encoderOffset, 0);
}

static addEncodedBy(builder:flatbuffers.Builder, encodedByOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, encodedByOffset, 0);
}

static addGenre(builder:flatbuffers.Builder, genreOffset:flatbuffers.Offset) {
  builder.addFieldOffset(9, genreOffset, 0);
}

static addLanguage(builder:flatbuffers.Builder, languageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(10, languageOffset, 0);
}

static addPerformer(builder:flatbuffers.Builder, performerOffset:flatbuffers.Offset) {
  builder.addFieldOffset(11, performerOffset, 0);
}

static addTrackNumber(builder:flatbuffers.Builder, trackNumber:bigint) {
  builder.addFieldInt64(12, trackNumber, null);
}

static addDisc(builder:flatbuffers.Builder, disc:bigint) {
  builder.addFieldInt64(13, disc, null);
}

static addTitle(builder:flatbuffers.Builder, titleOffset:flatbuffers.Offset) {
  builder.addFieldOffset(14, titleOffset, 0);
}

static addDate(builder:flatbuffers.Builder, dateOffset:flatbuffers.Offset) {
  builder.addFieldOffset(15, dateOffset, 0);
}

static addBitrate(builder:flatbuffers.Builder, bitrate:bigint) {
  builder.addFieldInt64(16, bitrate, null);
}

static addLyrics(builder:flatbuffers.Builder, lyricsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(17, lyricsOffset, 0);
}

static addRating(builder:flatbuffers.Builder, rating:number) {
  builder.addFieldFloat64(18, rating, null);
}

static addUrlSource(builder:flatbuffers.Builder, urlSourceOffset:flatbuffers.Offset) {
  builder.addFieldOffset(19, urlSourceOffset, 0);
}

static endFileAudioContainerMetadataBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createFileAudioContainerMetadataBuf(builder:flatbuffers.Builder, albumOffset:flatbuffers.Offset, albumArtistOffset:flatbuffers.Offset, artistOffset:flatbuffers.Offset, beatsPerMinute:number|null, commentOffset:flatbuffers.Offset, composerOffset:flatbuffers.Offset, copyrightOffset:flatbuffers.Offset, encoderOffset:flatbuffers.Offset, encodedByOffset:flatbuffers.Offset, genreOffset:flatbuffers.Offset, languageOffset:flatbuffers.Offset, performerOffset:flatbuffers.Offset, trackNumber:bigint|null, disc:bigint|null, titleOffset:flatbuffers.Offset, dateOffset:flatbuffers.Offset, bitrate:bigint|null, lyricsOffset:flatbuffers.Offset, rating:number|null, urlSourceOffset:flatbuffers.Offset):flatbuffers.Offset {
  FileAudioContainerMetadataBuf.startFileAudioContainerMetadataBuf(builder);
  FileAudioContainerMetadataBuf.addAlbum(builder, albumOffset);
  FileAudioContainerMetadataBuf.addAlbumArtist(builder, albumArtistOffset);
  FileAudioContainerMetadataBuf.addArtist(builder, artistOffset);
  if (beatsPerMinute !== null)
    FileAudioContainerMetadataBuf.addBeatsPerMinute(builder, beatsPerMinute);
  FileAudioContainerMetadataBuf.addComment(builder, commentOffset);
  FileAudioContainerMetadataBuf.addComposer(builder, composerOffset);
  FileAudioContainerMetadataBuf.addCopyright(builder, copyrightOffset);
  FileAudioContainerMetadataBuf.addEncoder(builder, encoderOffset);
  FileAudioContainerMetadataBuf.addEncodedBy(builder, encodedByOffset);
  FileAudioContainerMetadataBuf.addGenre(builder, genreOffset);
  FileAudioContainerMetadataBuf.addLanguage(builder, languageOffset);
  FileAudioContainerMetadataBuf.addPerformer(builder, performerOffset);
  if (trackNumber !== null)
    FileAudioContainerMetadataBuf.addTrackNumber(builder, trackNumber);
  if (disc !== null)
    FileAudioContainerMetadataBuf.addDisc(builder, disc);
  FileAudioContainerMetadataBuf.addTitle(builder, titleOffset);
  FileAudioContainerMetadataBuf.addDate(builder, dateOffset);
  if (bitrate !== null)
    FileAudioContainerMetadataBuf.addBitrate(builder, bitrate);
  FileAudioContainerMetadataBuf.addLyrics(builder, lyricsOffset);
  if (rating !== null)
    FileAudioContainerMetadataBuf.addRating(builder, rating);
  FileAudioContainerMetadataBuf.addUrlSource(builder, urlSourceOffset);
  return FileAudioContainerMetadataBuf.endFileAudioContainerMetadataBuf(builder);
}
}
